export const INPUT_BASE_CLASSES =
  'w-full rounded-xl border border-onboarding-primary/30 bg-onboarding-content-bg px-5 py-[18px] text-base text-onboarding-text-dark transition focus:border-onboarding-primary focus:outline-none';

export const cx = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(' ');

export const COUNTRY_CODES = [
  { code: '+54', label: 'Argentina (+54)' },
  { code: '+61', label: 'Australia (+61)' },
  { code: '+591', label: 'Bolivia (+591)' },
  { code: '+55', label: 'Brazil (+55)' },
  { code: '+56', label: 'Chile (+56)' },
  { code: '+57', label: 'Colombia (+57)' },
  { code: '+506', label: 'Costa Rica (+506)' },
  { code: '+53', label: 'Cuba (+53)' },
  { code: '+593', label: 'Ecuador (+593)' },
  { code: '+503', label: 'El Salvador (+503)' },
  { code: '+33', label: 'France (+33)' },
  { code: '+49', label: 'Germany (+49)' },
  { code: '+502', label: 'Guatemala (+502)' },
  { code: '+592', label: 'Guyana (+592)' },
  { code: '+509', label: 'Haiti (+509)' },
  { code: '+504', label: 'Honduras (+504)' },
  { code: '+91', label: 'India (+91)' },
  { code: '+353', label: 'Ireland (+353)' },
  { code: '+39', label: 'Italy (+39)' },
  { code: '+81', label: 'Japan (+81)' },
  { code: '+52', label: 'Mexico (+52)' },
  { code: '+31', label: 'Netherlands (+31)' },
  { code: '+64', label: 'New Zealand (+64)' },
  { code: '+505', label: 'Nicaragua (+505)' },
  { code: '+1', label: 'North America (+1)' },
  { code: '+507', label: 'Panama (+507)' },
  { code: '+595', label: 'Paraguay (+595)' },
  { code: '+51', label: 'Peru (+51)' },
  { code: '+7', label: 'Russia (+7)' },
  { code: '+65', label: 'Singapore (+65)' },
  { code: '+27', label: 'South Africa (+27)' },
  { code: '+82', label: 'South Korea (+82)' },
  { code: '+34', label: 'Spain (+34)' },
  { code: '+597', label: 'Suriname (+597)' },
  { code: '+46', label: 'Sweden (+46)' },
  { code: '+41', label: 'Switzerland (+41)' },
  { code: '+971', label: 'United Arab Emirates (+971)' },
  { code: '+44', label: 'United Kingdom (+44)' },
  { code: '+598', label: 'Uruguay (+598)' },
  { code: '+58', label: 'Venezuela (+58)' },
];

// Format phone number for display (North America: (555) 123-4567)
export const formatPhoneForDisplay = (digits: string, countryCode: string): string => {
  if (countryCode === '+1') {
    const cleaned = digits.replace(/\D/g, '');
    if (cleaned.length === 0) return '';
    if (cleaned.length <= 3) return `(${cleaned}`;
    if (cleaned.length <= 6) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
  }
  return digits;
};

export const extractDigits = (formatted: string): string => {
  return formatted.replace(/\D/g, '');
};

// Obfuscate email for display (e.g., "john@example.com" -> "j***@***.com")
export const obfuscateEmail = (email: string): string => {
  if (!email || !email.includes('@')) return email;

  const [localPart, domain] = email.split('@');
  const [domainName, ...tldParts] = domain.split('.');
  const tld = tldParts.join('.');

  const obfuscatedLocal = localPart.length > 1
    ? localPart[0] + '*'.repeat(Math.min(localPart.length - 1, 7))
    : localPart;

  const obfuscatedDomain = '*'.repeat(Math.min(domainName.length, 3));

  return `${obfuscatedLocal}@${obfuscatedDomain}.${tld}`;
};
